module.exports = __webpack_public_path__ + "img/sand-decal-18.c9093ad4.png";